import { useEffect, useState } from 'react';
import { useStyles } from './style';
import clsx from 'clsx';

function CounterDown({ minutes = 5, onFinish }) {
  const [timeLeft, setTimeLeft] = useState(minutes * 60);
  const [isFinished, setIsFinished] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsFinished(true);
      if (onFinish) onFinish();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, onFinish]);

  const formatTime = () => {
    const mins = Math.floor(timeLeft / 60);
    const secs = timeLeft % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <div>
      <span className={clsx(classes.CounterDown, isFinished ? 'TimeStop' : '')}>
        {formatTime()}
      </span>
    </div>
  );
}

export default CounterDown;
